import { render, staticRenderFns } from "./floatingBall.vue?vue&type=template&id=1f2c2ac2&scoped=true&"
import script from "./floatingBall.vue?vue&type=script&lang=js&"
export * from "./floatingBall.vue?vue&type=script&lang=js&"
import style0 from "./floatingBall.vue?vue&type=style&index=0&id=1f2c2ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c2ac2",
  null
  
)

export default component.exports